import { render, staticRenderFns } from "./TeamOfTheDay.vue?vue&type=template&id=0c403b5b&"
import script from "./TeamOfTheDay.vue?vue&type=script&lang=js&"
export * from "./TeamOfTheDay.vue?vue&type=script&lang=js&"
import style0 from "./TeamOfTheDay.vue?vue&type=style&index=0&id=0c403b5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports